<p *ngIf="item.link_location !== 'modal'">
  <a
    (click)="
      renderedService.openLinkHandler(
        $event,
        {
          type: item.item_type
            ? item.item_type.value && item.item_type.value.length > 0
              ? item.item_type.value
              : item.set_type
            : item.set_type,
          id: item.item_id.value
        },
        'item_link'
      )
    "
    [href]="'/'+ (item.item_type
    ? item.item_type.value && item.item_type.value.length > 0
      ? item.item_type.value
      : item.set_type
    : item.set_type) +'/'+item.item_id.value"
    >{{
      item?.translation_key || item.link_text?.value || item.label
        | translation
        |translationFromString | transformText  : item?.text_transform
    }}</a
  >
</p>
<p *ngIf="item.link_location === 'modal'" class="open-view-in-modal">
  <a
    (click)="
      openViewLink(
        $event,
        {
          type: item.item_type
            ? item.item_type.value && item.item_type.value.length > 0
              ? item.item_type.value
              : item.set_type
            : item.set_type,
          id: item.item_id.value
        },
        'read',
        'item_link'
      )
    "
    href="#"
    >{{
      item?.translation_key || item.link_text?.value || item.label
        | translation
        |translationFromString | transformText  : item?.text_transform
    }}</a
  >
</p>
